// lib/gtm.ts
type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[];
};

declare const window: WindowWithDataLayer;

export const GTM_ID = process.env.NEXT_PUBLIC_GTM;

export const gtm = {
  pushToDataLayer: (eventObj: Record<string, any>) => {
    if (typeof window.dataLayer !== "undefined") {
      window.dataLayer.push(eventObj);
    }
  },
};
